"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsxs)("g", {
      fill: "currentColor",
      fillRule: "nonzero",
      children: [(0, _jsxRuntime.jsx)("path", {
        d: "M15.52 4H8.392A4.396 4.396 0 004 8.391v7.13a4.396 4.396 0 004.391 4.39h7.13a4.396 4.396 0 004.39-4.39V8.39A4.396 4.396 0 0015.522 4zm2.98 11.52a2.983 2.983 0 01-2.98 2.98H8.392a2.983 2.983 0 01-2.98-2.98V8.392a2.983 2.983 0 012.98-2.98h7.13a2.983 2.983 0 012.979 2.98v7.13z"
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M11.956 7.856c-2.26 0-4.1 1.84-4.1 4.1s1.84 4.1 4.1 4.1 4.1-1.84 4.1-4.1-1.84-4.1-4.1-4.1zm0 6.788a2.691 2.691 0 01-2.688-2.688 2.691 2.691 0 012.688-2.688 2.691 2.691 0 012.688 2.688 2.691 2.691 0 01-2.688 2.688zM16.228 6.659a1.04 1.04 0 00-1.035 1.035c0 .272.11.54.304.732.192.192.459.304.73.304.274 0 .54-.112.733-.304a1.04 1.04 0 000-1.464 1.04 1.04 0 00-.732-.303z"
      })]
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=InstagramSolid.js.map